import { TextProps } from './styleModels';

export class LinkButtonProps {
  constructor(item = {}) {
    this.text = item.text || '';
    this.image = item.image;
    this.link = item.link;
    this.textProps = new TextProps(item.textProps);
  }
}
